(function (root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root) root.ESLSearchCore = api;
}(typeof window !== 'undefined' ? window : null, function () {
  'use strict';

  var MAX_INPUT_LENGTH = 120;
  var MAX_TOKENS = 12;
  var MAX_QUERY_LENGTH = 8192;
  var scopeClauses = {};
  var stopWords = /^(a|an|and|are|at|by|for|from|in|is|of|on|the|to|with)$/i;
  var validScopes = /^(all|bikes|scooters|parts)$/;
  var knownBrands = ['ADO', 'Fiido', 'Pure', 'Hampton', 'Engwe', 'Eleglide', 'Hidoes', 'Kukirin', 'Kugoo', 'Xiaomi', 'Segway', 'Ninebot', 'VIPCOO', 'Freesky', 'COSWHEEL', 'HIMO', 'Mercane', 'Dualtron', 'Kaabo', 'Bosch', 'Brompton', 'Carrera', 'Raleigh', 'Trek'];

  function fail(message, code) {
    var error = new RangeError(message);
    error.code = code;
    throw error;
  }

  function readInput(raw) {
    if (typeof raw !== 'string') return '';
    if (raw.length > MAX_INPUT_LENGTH) fail('Search is limited to 120 characters.', 'INPUT_TOO_LONG');
    var value = raw.replace(/[\u0000-\u001f\u007f]/g, ' ').trim();
    if (value && value.split(/\s+/).length > MAX_TOKENS) {
      fail('Search is limited to 12 words.', 'TOO_MANY_TOKENS');
    }
    return value;
  }

  function isAdvancedQuery(raw) {
    if (typeof raw !== 'string') return false;
    return /(?:^|[\s(])(?:[A-Za-z_][A-Za-z0-9_.]*\s*:|[-+]\S)/.test(raw) ||
      /\b(?:AND|OR|NOT)\b/.test(raw) || /"[^"\r\n]+"/.test(raw);
  }

  function hasSearchValue(raw) {
    var value = raw.replace(/(?:^|[\s(])[A-Za-z_][A-Za-z0-9_.]*\s*:/g, ' ')
      .replace(/\b(?:AND|OR|NOT)\b/g, '')
      .replace(/[\s()\[\]{}:;,.!?"'“”‘’\\+\-]+/g, '');
    return value.length > 0;
  }

  function modelAllowed(raw, expectedBrand) {
    if (new RegExp('\\b' + expectedBrand + '\\b', 'i').test(raw)) return true;
    return !knownBrands.some(function (brand) { return new RegExp('\\b' + brand + '\\b', 'i').test(raw); });
  }

  function isHelpQuery(raw) {
    if (typeof raw !== 'string') return false;
    var compact = raw.toLowerCase().replace(/[\s\-–—"“”]/g, '');
    return /^(cycle(to|2)work(schemes?|vouchers?|schemevouchers?)?|cyclescheme(vouchers?|schemes?)?)$/.test(compact);
  }

  function normalizeAliases(raw) {
    if (typeof raw !== 'string') return '';
    var value = raw.replace(/\s+/g, ' ').trim();
    if (modelAllowed(value, 'ADO')) {
      value = value.replace(/\bair\s*20(?:\s*(s|pro|ultra))?\b/gi, function (_, suffix) {
        suffix = (suffix || '').toLowerCase();
        return 'Air 20' + (suffix === 's' ? 'S' : suffix ? ' ' + suffix.charAt(0).toUpperCase() + suffix.slice(1) : '');
      });
    }
    if (modelAllowed(value, 'Fiido')) {
      value = value.replace(/\bc\s*11(?:\s*(pro))?\b/gi, function (_, pro) {
        return 'C11' + (pro ? ' Pro' : '');
      });
    }
    return value;
  }

  function quote(value) {
    return '"' + value.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"';
  }

  function tokenClause(token) {
    return '(title:' + quote(token) + ' OR vendor:' + quote(token) + ')';
  }

  function modelClause(aliases) {
    return '(' + aliases.map(function (alias) { return 'title:' + quote(alias); }).join(' OR ') + ')';
  }

  function isSku(token) {
    return token.length >= 2 && token.length <= 64 &&
      /^[A-Za-z0-9][A-Za-z0-9._/+\-]*$/.test(token) && /\d/.test(token) &&
      (/[A-Za-z]/.test(token) || /^\d{3,32}$/.test(token));
  }

  function focusedQuery(raw) {
    var normalized = normalizeAliases(raw);
    var hasAdo = modelAllowed(normalized, 'ADO');
    var hasFiido = modelAllowed(normalized, 'Fiido');
    var tokens = normalized.split(/\s+/).map(function (token) {
      return token.replace(/^[.,!?;:()[\]{}"'“”‘’]+|[.,!?;:()[\]{}"'“”‘’]+$/g, '');
    }).filter(function (token) { return /[A-Za-z0-9\u00c0-\uffff]/.test(token) && !stopWords.test(token); });
    var units = [];
    var i;
    for (i = 0; i < tokens.length; i += 1) {
      var token = tokens[i];
      var next = tokens[i + 1] || '';
      var after = tokens[i + 2] || '';
      if (hasAdo && /^Air$/i.test(token) && /^20S?$/i.test(next)) {
        var aliases;
        if (/^20S$/i.test(next)) {
          aliases = ['Air 20S', 'Air20S', 'Air 20 S'];
          i += 1;
        } else if (/^(Pro|Ultra)$/i.test(after)) {
          var suffix = /^Pro$/i.test(after) ? 'Pro' : 'Ultra';
          aliases = ['Air 20 ' + suffix, 'Air20 ' + suffix, 'Air20' + suffix];
          i += 2;
        } else {
          aliases = ['Air 20', 'Air20', 'Air 20S', 'Air20S'];
          i += 1;
        }
        units.push({ clause: modelClause(aliases) });
      } else if (hasFiido && /^C11$/i.test(token)) {
        var c11Aliases = ['C11', 'C 11', 'C11 Pro', 'C11Pro'];
        if (/^Pro$/i.test(next)) {
          c11Aliases = ['C11 Pro', 'C11Pro', 'C 11 Pro'];
          i += 1;
        }
        units.push({ clause: modelClause(c11Aliases) });
      } else if (/^e-?bikes?$/i.test(token) || (/^electric$/i.test(token) && /^bikes?$/i.test(next))) {
        if (/^electric$/i.test(token)) i += 1;
        units.push({ clause: modelClause(['electric bike', 'e-bike', 'ebike', 'e bike']) });
      } else {
        units.push({ clause: tokenClause(token), sku: isSku(token) ? token : null });
      }
    }
    if (!units.length) return null;
    var regular = units.map(function (unit) { return unit.clause; }).join(' AND ');
    var skuAlternatives = [];
    units.forEach(function (candidate, index) {
      if (!candidate.sku) return;
      skuAlternatives.push('(' + units.map(function (unit, unitIndex) {
        return unitIndex === index ? 'variants.sku:' + quote(candidate.sku) : unit.clause;
      }).join(' AND ') + ')');
    });
    return skuAlternatives.length ? '((' + regular + ') OR ' + skuAlternatives.join(' OR ') + ')' : regular;
  }

  function configureScopes(clauses) {
    if (!clauses || typeof clauses !== 'object') throw new TypeError('Scope clauses must be an object.');
    var next = {};
    ['bikes', 'scooters', 'parts'].forEach(function (scope) {
      var clause = clauses[scope];
      if (typeof clause !== 'string' || !clause.trim() || clause.length > 4096 || !hasSearchValue(clause)) {
        throw new TypeError('A non-empty native query clause is required for ' + scope + '.');
      }
      next[scope] = clause.trim();
    });
    scopeClauses = next;
  }

  function buildQuery(raw, options) {
    options = options || {};
    var scope = options.scope || 'all';
    var mode = options.mode || 'focused';
    if (!validScopes.test(scope)) throw new TypeError('Unknown search scope: ' + scope);
    if (mode !== 'focused' && mode !== 'broad') throw new TypeError('Unknown search mode: ' + mode);
    var value = readInput(raw);
    if (!value || !hasSearchValue(value)) return null;
    if (isHelpQuery(value)) return value;
    var advanced = isAdvancedQuery(value);
    var focused = advanced ? null : focusedQuery(value);
    if (!advanced && !focused) return null;
    var query = advanced || mode === 'broad' ? value : focused;
    if (!query) return null;
    if (scope !== 'all') {
      if (!scopeClauses[scope]) throw new Error('Search scope has not been configured: ' + scope);
      query = '(' + query + ') AND (' + scopeClauses[scope] + ')';
    }
    if (query.length > MAX_QUERY_LENGTH) fail('Generated search query is too long.', 'QUERY_TOO_LONG');
    return query;
  }

  return {
    buildQuery: buildQuery,
    normalizeAliases: normalizeAliases,
    isAdvancedQuery: isAdvancedQuery,
    isHelpQuery: isHelpQuery,
    configureScopes: configureScopes,
    limits: { inputLength: MAX_INPUT_LENGTH, tokens: MAX_TOKENS, queryLength: MAX_QUERY_LENGTH }
  };
}));
